export const ADMIN_ANALYTICS_ACTIONS = {
    ADMIN_ANALYTICS_REQUEST: "ADMIN_ANALYTICS_REQUEST",
    ADMIN_ANALYTICS_RESPONSE: "ADMIN_ANALYTICS_RESPONSE",
    ADMIN_ANALYTICS_ERROR: "ADMIN_ANALYTICS_ERROR",
};
export const ADMIN_PAGEVIEW_GRAPH_ACTIONS = {
    ADMIN_PAGEVIEW_GRAPH_REQUEST: "ADMIN_PAGEVIEW_GRAPH_REQUEST",
    ADMIN_PAGEVIEW_GRAPH_RESPONSE: "ADMIN_PAGEVIEW_GRAPH_RESPONSE",
    ADMIN_PAGEVIEW_GRAPH_ERROR: "ADMIN_PAGEVIEW_GRAPH_ERROR",
};
export const ADMIN_UNIQUEVIEW_GRAPH_ACTIONS = {
    ADMIN_UNIQUEVIEW_GRAPH_REQUEST: "ADMIN_UNIQUEVIEW_GRAPH_REQUEST",
    ADMIN_UNIQUEVIEW_GRAPH_RESPONSE: "ADMIN_UNIQUEVIEW_GRAPH_RESPONSE",
    ADMIN_UNIQUEVIEW_GRAPH_ERROR: "ADMIN_UNIQUEVIEW_GRAPH_ERROR",
};
export const ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS = {
    ADMIN_NAVIGATIONPATH_GRAPH_REQUEST: "ADMIN_NAVIGATIONPATH_GRAPH_REQUEST",
    ADMIN_NAVIGATIONPATH_GRAPH_RESPONSE: "ADMIN_NAVIGATIONPATH_GRAPH_RESPONSE",
    ADMIN_NAVIGATIONPATH_GRAPH_ERROR: "ADMIN_NAVIGATIONPATH_GRAPH_ERROR",
};
export const ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS = {
    ADMIN_ANALYTICS_CTA_GRAPH_REQUEST: "ADMIN_ANALYTICS_CTA_GRAPH_REQUEST",
    ADMIN_ANALYTICS_CTA_GRAPH_RESPONSE: "ADMIN_ANALYTICS_CTA_GRAPH_RESPONSE",
    ADMIN_ANALYTICS_CTA_GRAPH_ERROR: "ADMIN_ANALYTICS_CTA_GRAPH_ERROR",
};
export const ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS = {
    ADMIN_AVERAGE_SESSION_GRAPH_REQUEST: "ADMIN_AVERAGE_SESSION_GRAPH_REQUEST",
    ADMIN_AVERAGE_SESSION_GRAPH_RESPONSE: "ADMIN_AVERAGE_SESSION_GRAPH_RESPONSE",
    ADMIN_AVERAGE_SESSION_GRAPH_ERROR: "ADMIN_AVERAGE_SESSION_GRAPH_ERROR",
};
export const ADMIN_BOUNCE_RATE_GRAPH_ACTIONS = {
    ADMIN_BOUNCE_RATE_GRAPH_REQUEST: "ADMIN_BOUNCE_RATE_GRAPH_REQUEST",
    ADMIN_BOUNCE_RATE_GRAPH_RESPONSE: "ADMIN_BOUNCE_RATE_GRAPH_RESPONSE",
    ADMIN_BOUNCE_RATE_GRAPH_ERROR: "ADMIN_BOUNCE_RATE_GRAPH_ERROR",
};
export const ADMIN_CTA_GRAPH_ACTIONS = {
    ADMIN_CTA_GRAPH_REQUEST: "ADMIN_CTA_GRAPH_REQUEST",
    ADMIN_CTA_GRAPH_RESPONSE: "ADMIN_CTA_GRAPH_RESPONSE",
    ADMIN_CTA_GRAPH_ERROR: "ADMIN_CTA_GRAPH_ERROR",
};
export const ADMIN_DEVICE_BROWSER_CHART_ACTIONS = {
    ADMIN_DEVICE_BROWSER_CHART_REQUEST: "ADMIN_DEVICE_BROWSER_CHART_REQUEST",
    ADMIN_DEVICE_BROWSER_CHART_RESPONSE: "ADMIN_DEVICE_BROWSER_CHART_RESPONSE",
    ADMIN_DEVICE_BROWSER_CHART_ERROR: "ADMIN_DEVICE_BROWSER_CHART_ERROR",
};
export const ADMIN_COUNTRY_USERS_CHART_ACTIONS = {
    ADMIN_COUNTRY_USERS_CHART_REQUEST: "ADMIN_COUNTRY_USERS_CHART_REQUEST",
    ADMIN_COUNTRY_USERS_CHART_RESPONSE: "ADMIN_COUNTRY_USERS_CHART_RESPONSE",
    ADMIN_COUNTRY_USERS_CHART_ERROR: "ADMIN_COUNTRY_USERS_CHART_ERROR",
};
export const ADMIN_ANALYTICS_TABLEDATA_ACTIONS = {
    ADMIN_ANALYTICS_TABLEDATA_REQUEST: "ADMIN_ANALYTICS_TABLEDATA_REQUEST",
    ADMIN_ANALYTICS_TABLEDATA_RESPONSE: "ADMIN_ANALYTICS_TABLEDATA_RESPONSE",
    ADMIN_ANALYTICS_TABLEDATA_ERROR: "ADMIN_ANALYTICS_TABLEDATA_ERROR",
};
export const ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS = {
    ADMIN_ANALYTICS_TABLEDATA_CUSTOM_REQUEST: "ADMIN_ANALYTICS_TABLEDATA_CUSTOM_REQUEST",
    ADMIN_ANALYTICS_TABLEDATA_CUSTOM_RESPONSE: "ADMIN_ANALYTICS_TABLEDATA_CUSTOM_RESPONSE",
    ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ERROR: "ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ERROR",
};
export const ADMIN_ANALYTICS_EXITDATA_ACTIONS = {
    ADMIN_ANALYTICS_EXITDATA_REQUEST: "ADMIN_ANALYTICS_EXITDATA_REQUEST",
    ADMIN_ANALYTICS_EXITDATA_RESPONSE: "ADMIN_ANALYTICS_EXITDATA_RESPONSE",
    ADMIN_ANALYTICS_EXITDATA_ERROR: "ADMIN_ANALYTICS_EXITDATA_ERROR",
};
export const ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS = {
    ADMIN_ANALYTICS_DATA_TABLE_DATA_REQUEST: "ADMIN_ANALYTICS_DATA_TABLE_DATA_REQUEST",
    ADMIN_ANALYTICS_DATA_TABLE_DATA_RESPONSE: "ADMIN_ANALYTICS_DATA_TABLE_DATA_RESPONSE",
    ADMIN_ANALYTICS_DATA_TABLE_DATA_ERROR: "ADMIN_ANALYTICS_DATA_TABLE_DATA_ERROR",
};
export const ADMIN_ADSLOG_DATA_TABLE_ACTIONS = {
    ADMIN_ADSLOG_DATA_TABLE_REQUEST: "ADMIN_ADSLOG_DATA_TABLE_REQUEST",
    ADMIN_ADSLOG_DATA_TABLE_RESPONSE: "ADMIN_ADSLOG_DATA_TABLE_RESPONSE",
    ADMIN_ADSLOG_DATA_TABLE_ERROR: "ADMIN_ADSLOG_DATA_TABLE_ERROR",
};